export function arrayIsNotEmpty (arr)
{
	return arr && Array.isArray(arr) && arr.length > 0;
}

export function isEmptyArray (arr)
{
	return arr && Array.isArray(arr) && arr.length === 0;
}

export function itemsCountIs (arr, length)
{
	return arr && Array.isArray(arr) && arr.length === length;
}

export function emptyArrayIfNotDefined (arr)
{
	if (arr === undefined || arr === null)
	{
		return [];
	}

	return arr;
}
